<template>
	<div v-if="model && !loading">
    <div v-if="model.deleted" class="alert alert-danger">
      <p class=""> <b> ATTENZIONE</b> Questo cantiere è un cantiere eliminato. Le modifiche che apporti non saranno visibili</p>
    </div>
		<h2>
			<router-link to="/sites">
    			<i class="icon-minimal-left tim-icons" />
			</router-link>
			{{model.name}}
		</h2>

    <site-form :model="model" :on-submit="addSiteSubmit"></site-form>

    <card class="mt-3 responsive-card-table">
      <template slot="header">
        <div class="row">
          <div class="col-12 col-md-6">
            <h4>Gestione Motori</h4>
          </div>
          <div class="col-12 col-md-6 text-md-right">
            <router-link :to="`/sites/${$route.params.id}/engines/create`">
              <base-button type="primary">
                <i class="tim-icons icon-simple-add"></i>
                Crea nuovo
              </base-button>
            </router-link>
          </div>
        </div>
      </template>
      <engines-table :site="model"></engines-table>
    </card>

    <site-attachments 
      :site="model"/>
	</div>
	<loading v-else />
</template>
<script>
import SiteForm from '@/components/Sites/SiteForm.vue'
import SiteAttachments from '@/components/Sites/SiteAttachments.vue'
import EnginesTable  from '@/components/Engines/EnginesTable.vue'
// import SitesTable from './SitesTable.vue';
import { mapState, mapActions } from 'vuex'


export default{
  computed: {
    ...mapState({
		  model: state => state.sites.site,
		  loading: state => state.sites.loading,
    })
  },
  mounted() {
    this.get(this.$route.params.id);
  },
  beforeRouteUpdate (to,from,next) {
    this.get(to.params.id);
    next()
  },
  components: {
    SiteForm,
    SiteAttachments,
    EnginesTable
  },
  methods: {
    ...mapActions('sites', {
      get: 'get',
      update: 'update',
      delete: 'delete'
    }),
    addSiteSubmit() {
    	this.update(this.model)
    },	
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
  },
}	
</script>